export default {"src":"/_next/static/media/chevrons-right.542435b4.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};